import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';

@Injectable({providedIn: 'root'})
export class ComandaClienteService extends ServerService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  obtenhaMinhaComanda(pedido: any = null): Promise<any> {
    return this.obtenha('/comandas/minha-comanda', {}).catch((erro: any) => {
      if(!pedido || !this.ehErroDeSessaoDaComanda(erro))
        return Promise.reject(erro);

      const idMesa = Number(pedido.mesa?.id);
      const idCartaoCliente = Number(pedido.comandaValidada?.idCartaoCliente || pedido.idCartaoCliente);
      if(!idMesa || !idCartaoCliente)
        return Promise.reject(erro);

      return this.facaPost(`/comandas/mesa/${encodeURIComponent(idMesa)}/cartao-cliente/validar`, {
        mesa: {id: idMesa},
        idCartaoCliente
      }).then(() => this.obtenhaMinhaComanda());
    });
  }

  gerePix(nome: string, valorConfirmado: number): Promise<any> {
    return this.facaPost('/comandas/minha-comanda/pix', {cliente: {nome}, valorConfirmado});
  }

  sincronizePix(pagamento: any, forcar = false): Promise<any> {
    const endpoint = `/comandas/minha-comanda/pix/${pagamento.id}/sincronize/${pagamento.statusNumero}`;
    return this.obtenha(endpoint, forcar ? {forcar: '1'} : {});
  }

  cancelePix(pagamento: any): Promise<any> {
    return this.facaPost(`/comandas/minha-comanda/pix/${pagamento.id}/cancele`, {});
  }

  private ehErroDeSessaoDaComanda(erro: any): boolean {
    const mensagem = String(erro || '').toLowerCase();
    return mensagem.indexOf('qr codes') >= 0 || mensagem.indexOf('sessão da comanda') >= 0 ||
      mensagem.indexOf('sessao da comanda') >= 0;
  }
}
